import * as React from 'react'
import * as ReactDOM from 'react-dom'
import './index.css'
import App from './App.conn'
import VorurPage from './containers/VorurPage'
import FrontPage from './containers/FrontPage'
import UmOkkurPage from './containers/UmOkkurPage'
import HafaSambandPage from './containers/HafaSambandPage'
import SingleVorur from './containers/SingleVorur'
import CompanyPage from './containers/CompanyPage'
import { Switch, Route, BrowserRouter as Router } from 'react-router-dom'
import { Provider } from 'react-redux'
import { unregister } from './registerServiceWorker'
import { applyMiddleware, createStore, compose } from 'redux'

import reducers from './reducers'

import createSagaMiddleware from 'redux-saga'
import mySaga from './sagas'
import * as ReactGA from 'react-ga'

const sagaMiddleware = createSagaMiddleware()
const composeEnhancers =
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store = createStore(
  reducers,
  {},
  composeEnhancers(applyMiddleware(sagaMiddleware)),
)

sagaMiddleware.run(mySaga)

ReactGA.initialize('UA-162408753-1')

ReactDOM.render(
  <Provider store={store}>
    <App>
      <Router>
        <Switch>
          <Route path="/" exact component={FrontPage} />
          <Route path="/vorur" exact component={VorurPage} />
          <Route path="/um-okkur" component={UmOkkurPage} />
          <Route path="/hafa-samband" component={HafaSambandPage} />
          <Route path="/vorur/:id/:vorumerki/:lina" component={SingleVorur} />
          <Route path="/vorur/:id/:vorumerki" component={SingleVorur} />
          <Route path="/vorur/:id" component={SingleVorur} />
          <Route path="/fyrirtaeki/:id" component={CompanyPage} />
        </Switch>
      </Router>
    </App>
  </Provider>,
  document.getElementById('root') as HTMLElement,
)

unregister()



// WEBPACK FOOTER //
// ./src/index.tsx